module.exports = __webpack_public_path__ + "img/inHomeIcon.4b5df76e.svg";